import { Fragment, useMemo } from 'react';
import Emoji from './Emoji';
import { graphemes, isEmojiGrapheme } from '../lib/emoji';

/** Обычный текст сообщения, но эмодзи внутри — картинки Noto, а не системный шрифт. */
export default function EmojiText({ text }: { text: string }) {
  const nodes = useMemo(() => {
    const out: { text?: string; emoji?: string }[] = [];
    let buf = '';
    for (const g of graphemes(text)) {
      if (isEmojiGrapheme(g)) {
        if (buf) {
          out.push({ text: buf });
          buf = '';
        }
        out.push({ emoji: g });
      } else {
        buf += g;
      }
    }
    if (buf) out.push({ text: buf });
    return out;
  }, [text]);

  return (
    <>
      {nodes.map((n, i) => (
        <Fragment key={i}>{n.emoji ? <Emoji char={n.emoji} /> : n.text}</Fragment>
      ))}
    </>
  );
}
